import React from "react";
import {Form,Col,Container} from "react-bootstrap";
import {YesNoDrop,NumInput,CustomDrop,TextInput,Diagnosis} from './dropdowns/components'


class  MedicalHistory extends React.Component {
    handleChange = (event) =>{
        this.props.handler('medical_history',event);
    }
    render(){
   
    return(
        <Container style={{"maxWidth":"1600px"}}>
            
            <h3>Medical History</h3><br/>
            <Form>
            <Form.Row>
            <NumInput title="Age of onset " name="age_onset"   disabled ={this.props.disabled } val={this.props.data!=null? this.props.data:null}handler={this.handleChange}/>
            <NumInput title="Disease duration (in years)"  name={"disease_duration"} disabled ={this.props.disabled } val={this.props.data!=null? this.props.data:null}handler={this.handleChange}/>
            <CustomDrop title="First symptom" val={this.props.data!=null? this.props.data:null}
             disabled ={this.props.disabled}
              name={"first_symptom"}
               handler={this.handleChange}
                options={["","Motor","non-Motor"]}/>
            </Form.Row>
            <Form.Row>
            <Diagnosis title="Initial Diagnosis" name="initial_diagnosis"   disabled ={this.props.disabled } val={this.props.data!=null? this.props.data:null}handler={this.handleChange}/>
            </Form.Row>
            </Form>
            <h4>First Motor Symptom</h4><br/>
            <Form>
                
                <Form.Row>
                    <NumInput title="Age of onset of first motor symptom" name="age_onset_motor"   disabled ={this.props.disabled } val={this.props.data!=null? this.props.data:null}handler={this.handleChange}/>
                </Form.Row>
                <Form.Row>
                 {/* <Form.Group as={Col}>
                     <Form.Label>Tremor</Form.Label>
                     <Form.Control as={"select"} name={'tremor'} onChange={this.handleChange}>
                            <option> </option>
                            <option> Yes </option>
                            <option> No</option>
                          
                     </Form.Control>
                 </Form.Group> */}
                 <YesNoDrop title={"Tremor"} val={this.props.data!=null? this.props.data:null} disabled ={this.props.disabled}  name={"tremor"} handler={this.handleChange}/>
                 {/* <Form.Group as={Col}>
                     <Form.Label>Slowness</Form.Label>
                     <Form.Control as={"select"} name={'slowness'} onChange={this.handleChange}>
                            <option> </option>
                            <option> Yes </option>
                            <option> No</option>
                          
                     </Form.Control>
                 </Form.Group> */}
                 <YesNoDrop title={"Slowness"} val={this.props.data!=null? this.props.data:null} disabled ={this.props.disabled} name={"slowness"} handler={this.handleChange}/>
                 {/* <Form.Group as={Col}>
                     <Form.Label>Dystonia</Form.Label>
                     <Form.Control as={"select"} name={'dystonia'} onChange={this.handleChange}>
                            <option> </option>
                            <option> Yes </option>
                            <option> No</option>
                          
                     </Form.Control>
                 </Form.Group> */}
                 <YesNoDrop title={"Dystonia"} val={this.props.data!=null? this.props.data:null}disabled ={this.props.disabled}  name={"dystonia"} handler={this.handleChange}/>
                 
                 
                </Form.Row>
                <Form.Row>
                    {/* <Form.Group as={Col}>
                        <Form.Label>Gait Problems</Form.Label>
                        <Form.Control as={"select"} name={'gait_problems'} onChange={this.handleChange}>
                                <option> </option>
                                <option> Yes </option>
                                <option> No</option>
                            
                        </Form.Control>
                    </Form.Group> */}
                    <YesNoDrop title={"Gait Problems"}  val={this.props.data!=null? this.props.data:null} disabled ={this.props.disabled} name={"gait_problems"} handler={this.handleChange}/>
                    {/* <Form.Group as={Col}>
                        <Form.Label>Rigidity/Stiffness</Form.Label>
                        <Form.Control as={"select"} name={'rigidity_stiffness'} onChange={this.handleChange}>
                                <option> </option>
                                <option> Yes </option>
                                <option> No</option>
                            
                        </Form.Control>                        
                    </Form.Group> */}
                    <YesNoDrop title={"Rigidity/Stiffness"} val={this.props.data!=null? this.props.data:null} disabled ={this.props.disabled} name={"rigidity_stiffness"} handler={this.handleChange}/>
                    {/* <Form.Group as={Col}>
                        <Form.Label>Falls</Form.Label>
                        <Form.Control as={"select"} name={'falls' }onChange={this.handleChange}>
                                <option> </option>
                                <option> Yes </option>
                                <option> No</option>
                            
                        </Form.Control>                        
                    </Form.Group> */}
                    <YesNoDrop title={"Falls"} name={"falls"} val={this.props.data!=null? this.props.data:null} disabled ={this.props.disabled}  handler={this.handleChange}/>
                    
                </Form.Row>
                <Form.Row>
                {/* <Form.Group as={Col}>
                        <Form.Label>Localization of first symptom</Form.Label>
                        <Form.Control as={"select"} name={'localization_first_symptom'} onChange={this.handleChange}>
                                <option> </option>
                                <option> right arm </option>
                                <option> left arm</option>
                                <option>right leg</option>
                                <option>left leg</option>
                                <option>right side</option>
                                <option>left side</option>
                            
                        </Form.Control>                        
                    </Form.Group> */}
                    <CustomDrop title="Localization of first motor symptom" val={this.props.data!=null? this.props.data:null} disabled ={this.props.disabled} name={"localization_first_motor_symptom"} handler={this.handleChange} options={["","Right arm","Left arm","Right leg","Left leg","Right side","Left side","Both sides symmetricaly"]}/>`
                    
                </Form.Row>
                
               
                <h4>First Non-motor Symptom</h4>
                <Form.Row>
                    <NumInput title="Age of onset of first non-motor symptom" name="age_onset_non_motor"   disabled ={this.props.disabled } val={this.props.data!=null? this.props.data:null}handler={this.handleChange}/>
                    <YesNoDrop title={"Constipation"} val={this.props.data!=null? this.props.data:null} disabled ={this.props.disabled} name={"constipation_non_motor"} handler={this.handleChange}/>
                </Form.Row>
                <Form.Row>
                    {/* <Form.Group as={Col}>
                        <Form.Label>Memory / executive problems</Form.Label>
                        <Form.Control as={"select"} name={'memeory_exectuvie_problems'} onChange={this.handleChange}>
                                    <option> </option>
                                    <option>Yes </option>
                                    <option>No </option>
                                
                        </Form.Control>
                    </Form.Group> */}
                    <YesNoDrop title={"Memory / Executive problems"} val={this.props.data!=null? this.props.data:null} disabled ={this.props.disabled} name={"memory_executive_problems"} handler={this.handleChange}/>

                    <YesNoDrop title={"Pain"} val={this.props.data!=null? this.props.data:null} disabled ={this.props.disabled} name={"pain"} handler={this.handleChange}/>
                    {/* <Form.Group as={Col}>
                        <Form.Label>Personality Change</Form.Label>
                        <Form.Control as={"select"} name={'personality_change'} onChange={this.handleChange}>
                                    <option> </option>
                                    <option>Yes </option>
                                    <option>No </option>
                                
                        </Form.Control>
                    </Form.Group> */}
                    <YesNoDrop title={"Personality change"} val={this.props.data!=null? this.props.data:null} disabled ={this.props.disabled}  name="personality_change" handler={this.handleChange}/>
                    {/* <Form.Group as={Col}>
                        <Form.Label>Apathy</Form.Label>
                        <Form.Control as={"select"} name={'apathy'} onChange={this.handleChange}>
                                    <option> </option>
                                    <option>Yes </option>
                                    <option>No </option>
                                
                        </Form.Control>
                    </Form.Group> */}
                    <YesNoDrop title={"Apathy"}  val={this.props.data!=null? this.props.data:null} disabled ={this.props.disabled} name={"apathy"} handler={this.handleChange}/>
                    
                </Form.Row>
                <Form.Row >
                {/* <Form.Group as={Col}>
                        <Form.Label>Depression</Form.Label>
                        <Form.Control as={"select"} name={'depression'} onChange={this.handleChange}>
                                    <option> </option>
                                    <option>Yes </option>
                                    <option>No </option>
                                
                        </Form.Control>
                    </Form.Group> */}
                    <YesNoDrop title={"Depression"} val={this.props.data!=null? this.props.data:null} disabled ={this.props.disabled} name={"depression"} handler={this.handleChange}/>

                    {/* <Form.Group as={Col}>
                        <Form.Label>Other neuropsychiatric symptoms</Form.Label>
                        <Form.Control as={"select"} name={'other_neuropsychiatric'} onChange={this.handleChange}>
                                    <option> </option>
                                    <option>Yes </option>
                                    <option>No </option>
                                
                        </Form.Control>
                    </Form.Group> */}
                    <YesNoDrop title={"Other neuropsychiatric symptoms"} val={this.props.data!=null? this.props.data:null} disabled ={this.props.disabled}  name={"other_neuropsychiatric"} handler={this.handleChange}/>
                </Form.Row><br/>
                <Form.Row>
                {/* <Form.Group as={Col}>
                        <Form.Label>Erectile dysfunction</Form.Label>
                        <Form.Control as={"select"} name={'erectile_dysfuncion'} onChange={this.handleChange}>
                                    <option> </option>
                                    <option>Yes </option>
                                    <option>No </option>
                                
                        </Form.Control>
                    </Form.Group> */}
                    <YesNoDrop title={"Erectile dysfunction"} val={this.props.data!=null? this.props.data:null} disabled ={this.props.disabled}   name={'erectile_dysfuncion'} handler={this.handleChange}/>
                    {/* <Form.Group as={Col}>
                        <Form.Label>Urinary dysfunction</Form.Label>
                        <Form.Control as={"select"} name={'urinary_dysfuncion'} onChange={this.handleChange}> 
                                    <option> </option>
                                    <option>Yes </option>
                                    <option>No </option>
                                
                        </Form.Control>
                    </Form.Group> */}
                    <YesNoDrop title={"Urinary dysfunction"} val={this.props.data!=null? this.props.data:null}  disabled ={this.props.disabled}  name={"urinary_dysfunction"} handler={this.handleChange}/>
                    {/* <Form.Group as={Col}>
                        <Form.Label>Dizziness when standing</Form.Label>
                        <Form.Control as={"select"} name={'dizzines_standing'} onChange={this.handleChange}>
                                    <option> </option>
                                    <option>Yes </option>
                                    <option>No </option>
                                
                        </Form.Control>
                    </Form.Group> */}
                    <YesNoDrop title={"Dizziness when standing"} val={this.props.data!=null? this.props.data:null}  disabled ={this.props.disabled} name={"dizziness_standing"} handler={this.handleChange}/>
                    <YesNoDrop title={"Other autonomic symptom"} val={this.props.data!=null? this.props.data:null}  disabled ={this.props.disabled} name={"other_autonomic_symptom"} handler={this.handleChange}/>
                    
                </Form.Row>
               
                <Form.Row>
                {/* <Form.Group as={Col}>
                        <Form.Label>Double Vision</Form.Label>
                        <Form.Control as={"select"} name={'double_vision'} onChange={this.handleChange}>
                                    <option> </option>
                                    <option>Yes </option>
                                    <option>No </option>
                                
                        </Form.Control>
                    </Form.Group> */}
                    <YesNoDrop title={"Double vision"}  val={this.props.data!=null? this.props.data:null} disabled ={this.props.disabled}  name={"double_vision"} handler={this.handleChange}/>
                    {/* <Form.Group as={Col}>
                        <Form.Label>Photophobia</Form.Label>
                        <Form.Control as={"select"} name={'photophobia'} onChange={this.handleChange}> 
                                    <option> </option>
                                    <option>Yes </option>
                                    <option>No </option>
                                
                        </Form.Control>
                    </Form.Group> */}
                    <YesNoDrop title={"Photophobia"} val={this.props.data!=null? this.props.data:null}  disabled ={this.props.disabled} name={"photophobia"} handler={this.handleChange}/>
                    <YesNoDrop title={"Blepharospasm"} val={this.props.data!=null? this.props.data:null}  disabled ={this.props.disabled} name={"blepharospasm"} handler={this.handleChange}/>
                    {/* <Form.Group as={Col}>
                        <Form.Label>Eye-lid apraxia</Form.Label>
                        <Form.Control as={"select"} name={'eye_lid_apraxia'} onChange={this.handleChange}>
                                    <option> </option>
                                    <option>Yes </option>
                                    <option>No </option>
                                
                        </Form.Control>
                    </Form.Group> */}
                   
                </Form.Row>
                <Form.Row>
                {/* <Form.Group as={Col}>
                        <Form.Label>Blured Vision</Form.Label>
                        <Form.Control as={"select"} name={'blured_vision'} onChange={this.handleChange}>
                                    <option> </option>
                                    <option>Yes </option>
                                    <option>No </option>
                                
                        </Form.Control>
                    </Form.Group> */}
                    <YesNoDrop title={"Eye-lid apraxia"} val={this.props.data!=null? this.props.data:null}  disabled ={this.props.disabled} name={'eye_lid_apraxia'} handler={this.handleChange}/>
                    <YesNoDrop title={"Blurred Vision"} val={this.props.data!=null? this.props.data:null}   disabled ={this.props.disabled} name={"blurred_vision"} handler={this.handleChange}/>
                    {/* <Form.Group as={Col}>
                        <Form.Label>Other Visual Symptom</Form.Label>
                        <Form.Control as={"select"} name={'other_visual_symtom'} onChange={this.handleChange}>
                                    <option> </option>
                                    <option>Yes </option>
                                    <option>No </option>
                                
                        </Form.Control>
                    </Form.Group> */}
                    <YesNoDrop title={"Other visual symptom"} val={this.props.data!=null? this.props.data:null} disabled ={this.props.disabled} name={"other_visual_symptom"} handler={this.handleChange}/>
                </Form.Row>
                <Form.Row>
                {/* <Form.Group as={Col}>
                        <h5>Hyposmia</h5>
                        <Form.Control as={"select"} name={'hyposmia'}onChange={this.handleChange}  >
                                    <option> </option>
                                    <option>Yes </option>
                                    <option>No </option>
                                
                        </Form.Control>
                </Form.Group> */}

                <YesNoDrop title={"Hyposmia"} name={"hyposmia"} val={this.props.data!=null? this.props.data:null} disabled ={this.props.disabled}  handler={this.handleChange}/>
                
                
                {/* <Form.Group as={Col}>
                        <h5>REM Sleep behaviour disorder</h5>
                        <Form.Control as={"select"} name={'rem_disorder'} onChange={this.handleChange}>
                                    <option> </option>
                                    <option>Yes </option>
                                    <option>No </option>
                                
                        </Form.Control>
                </Form.Group> */}
                <YesNoDrop title={"REM sleep behaviour disorder"} val={this.props.data!=null? this.props.data:null}  disabled ={this.props.disabled}  name={"rem_disorder"} handler={this.handleChange}/>
                <YesNoDrop title={"Restless legs syndrome"} val={this.props.data!=null? this.props.data:null}  disabled ={this.props.disabled}  name={"restless_legs_sydromes"} handler={this.handleChange}/>
                
                
                {/* <Form.Group as={Col}>
                        <h5>Obstructive sleep apnoea</h5>
                        <Form.Control as={"select"} name={'sleep_apnoea'} onChange={this.handleChange}>
                                    <option> </option>
                                    <option>Yes </option>
                                    <option>No </option>
                                
                        </Form.Control>
                        </Form.Group> */}
                    <YesNoDrop title={"Obstructive sleep apnoea"} val={this.props.data!=null? this.props.data:null}  disabled ={this.props.disabled}   name={"sleep_apnoea"} handler={this.handleChange}/>
                </Form.Row>
                <Form.Group>
                    <Form.Label>Other Diseases</Form.Label>
                    <Form.Control as={'textarea'} name={'other_diseases'} onChange={this.handleChange} value={this.props.data!=null? this.props.data['other_diseases']:null} disabled={this.props.disabled}/>
                </Form.Group>
                <h4>Diagnosis at presentation</h4>
                <Form.Row>
                    
                    <YesNoDrop title={"Unclassified  Parkinsonism"} val={this.props.data!=null? this.props.data:null}  disabled ={this.props.disabled}   name={"unclassified_parkinsonism"} handler={this.handleChange}/>
                </Form.Row>
                
                <Form.Row>
                <CustomDrop title="Parkinson’s disease" val={this.props.data!=null? this.props.data:null} disabled ={this.props.disabled} name={"parkinsons_disease"} handler={this.handleChange} options={["","Clinically established","Probable","Possible"]}/>
                </Form.Row>
                <Form.Row>
                <CustomDrop title="Progressive supranuclear palsy" val={this.props.data!=null? this.props.data:null} disabled ={this.props.disabled} name={"progressive_supranuclear_palsy"} handler={this.handleChange} options={["","Probable","Possible","Suggestive of"]}/>
                </Form.Row>
                <Form.Row>
                <CustomDrop title="Multiple System Atrophy" val={this.props.data!=null? this.props.data:null} disabled ={this.props.disabled} name={"msa"} handler={this.handleChange} options={["","Clinically established","Probable","Possible",]}/>
                </Form.Row>
                <Form.Row>
                   
                </Form.Row>
            </Form>
       
        </Container>
    )
                }
}
export default MedicalHistory;